const LANGUAGES = ['es', 'en', 'ca-ES'];

const getLanguageLabel = (language) => {
    if (language === 'ca-ES') {
        return 'CA';
    }

    return language?.toUpperCase() || 'ES';
};

export const getLanguageHref = (language) => {
    if (language === 'ca-ES') {
        return '/es-ca/';
    }

    return `/${language}/` || '/es/';
};

const getLanguageLinks = (
    alternateLanguages,
    currentLanguage,
    specificLanguages = null,
) => {
    return (specificLanguages || LANGUAGES)
        .filter((l) => l !== currentLanguage)
        .map((l) => {
            const existingPage = alternateLanguages?.find(
                (al) => al.language === l,
            );
            return {
                label: getLanguageLabel(l),
                href: existingPage ? existingPage?.href : getLanguageHref(l),
                column: 1,
            };
        });
};

export const getLanguageNavByAlternateLanguages = (
    alternateLanguages = [],
    specificLanguages = null,
) => {
    const currentLanguage = alternateLanguages.find(({ active }) => !!active);

    return [
        {
            label: getLanguageLabel(currentLanguage?.language),
            href: currentLanguage?.href,
            childLinks: getLanguageLinks(
                alternateLanguages,
                currentLanguage?.language,
                specificLanguages,
            ),
        },
    ];
};

const removeHeadStyle = () => {
    const headStyle = window.document.querySelector('#cssProviderStyle');
    if (headStyle) {
        headStyle.remove();
        return true;
    }

    return false;
};

const fillWebsiteField = () => {
    const fields = window.document.querySelectorAll(
        '[data-editorblocktype="Field-url"][hidden]',
    );
    [...fields].forEach((field) => {
        const label = field.querySelector('label');
        if (label.innerText?.toLowerCase().trim() === 'website') {
            const input = field.querySelector('input');
            if (input) {
                input.value = window.location.href;
            }
        }
    });
};

const INTERVAL_REMOVE_TIME = 200;

export const removeDynamicsStyle = (dom) => {
    let timeout = null;

    const theTimeout = () => {
        const formBlocks = dom.querySelectorAll('div[data-form-block-id]');
        let setupTimeout = false;

        if (formBlocks?.length) {
            [...formBlocks].forEach((block) => {
                let form = block.querySelector('form');
                if (form) {
                    let styles = form.querySelectorAll('style');
                    if (styles?.length) {
                        [...styles].forEach((style) => {
                            style.remove();
                        });
                    }

                    removeHeadStyle();
                    fillWebsiteField();

                    if (window.MsCrmMkt?.MsCrmFormLoader) {
                        const removeStyleInterval = () => {
                            let interval = null;
                            let times = 20;

                            interval = setInterval(() => {
                                if (removeHeadStyle() || !times) {
                                    fillWebsiteField();
                                    window.clearInterval(interval);
                                    interval = null;
                                }

                                times--;
                            }, INTERVAL_REMOVE_TIME);
                        };

                        window.MsCrmMkt.MsCrmFormLoader.on(
                            'afterFormSubmit',
                            () => {
                                removeStyleInterval();

                                setTimeout(() => {
                                    const submitDiv =
                                        window.document.querySelector(
                                            '.onFormSubmittedFeedback',
                                        );

                                    if (submitDiv) {
                                        const buttons =
                                            submitDiv.querySelectorAll(
                                                'button',
                                            );

                                        if (buttons?.length) {
                                            [...buttons].forEach((button) => {
                                                button.addEventListener(
                                                    'click',
                                                    removeStyleInterval,
                                                );
                                            });
                                        }
                                    }
                                }, 2000);
                            },
                        );
                    }
                } else {
                    setupTimeout = true;
                }
            });

            if (setupTimeout) {
                timeout = setTimeout(() => {
                    theTimeout(dom);
                }, INTERVAL_REMOVE_TIME);
            }
        }
    };

    timeout = setTimeout(theTimeout, INTERVAL_REMOVE_TIME);
    return timeout;
};

export const getScript = (script) => {
    if (typeof window === 'undefined') {
        return null;
    }

    let newScript = window.document.createElement('script');
    if (script.src) {
        newScript.src = script.src;
    } else if (script.content) {
        let inlineScript = window.document.createTextNode(script.content);
        newScript.appendChild(inlineScript);
    }

    return newScript;
};
